import GradientContainer from "@app/components/gradient/gradient-container";
import EngagementSectionBottomContent from "./bottom-content";
import EngagementSectionHeader from "./header";
import EngagementSectionMidContent from "./mid-content";
import EngagementSectionTopContent from "./top-content";

const EngagementSection = () => {
  return (
    <GradientContainer>
      <section className="py-16 px-8 md:p-12 lg:p-24 text-light flex flex-col items-center space-y-16">
        <EngagementSectionHeader />
        <EngagementSectionTopContent />
        <EngagementSectionMidContent />
        <EngagementSectionBottomContent />
      </section>
    </GradientContainer>
  );
};

export default EngagementSection;
